// @flow

// faq link setting
const getExportLocale = (locale?: string) => {
  const availableLocales = ['en', 'es', 'fr', 'it', 'ru'];
  const defaultLocale = 'en';
  if (!locale) {
    return defaultLocale;
  }
  return (
    availableLocales.find((l) => locale.toLowerCase() === l) || defaultLocale
  );
};

const ebayDomains = {
  en: 'com',
  ru: 'com',
  es: 'es',
  pt: 'com',
  fr: 'fr',
  it: 'it',
};

const getEbayDomain = (locale: string = 'en'): string =>
  `https://www.ebay.${ebayDomains[locale] || 'com'}`;

export default {
  signIn: '/auth/ebay?origin=%2Fstock',
  faq: (locale?: string): string => {
    switch (locale) {
      case 'ja':
        return 'https://ebay.co.jp/ebaymag-faq';
      case 'ko':
        return 'https://www.ebay.co.kr/ebaymag-faq';
      default:
        return `https://help.ebaymag.com/${getExportLocale(
          locale
        )}/collections/4047426-faq`;
      // return `https://export.ebay.com/${getExportLocale(locale)}/faq`;
    }
  },
  helpCenter: 'https://help.ebaymag.com',
  helpEbay: (locale: string): string => `${getEbayDomain(locale)}/help/home`,
  eportalLinks: {
    ja: 'https://eportal.ebay.co.jp/portals/inquiry_input',
    ko: 'https://e-portal.ebay.co.kr/portals/inquiry_input',
  },
  feedbackLinks: {
    ja: {
      holiday: 'https://help.ebaymag.com/ja/articles/4219600-ebaymag',
    },
  },
  moreAboutPaindInsertions: {
    ru: 'https://export.ebay.com/ru/fees-and-payments/seller-fees/insertion-fees',
    en: 'https://export.ebay.com/en/start-sell/selling-basics/seller-fees/insertion-fees',
    es: 'https://export.ebay.com/es/start-sell/seller-fees/insertion-fees',
    pt: 'https://export.ebay.com/pt/start-sell/seller-fees/insertion-fees',
  },
  dhl: 'https://export.ebay.com/ru/shipping/delivery-service-integration/dhl',
};
